module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "商品详情",
      "backFn": "true"
    },
    on: {
      "back": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), (_vm.product) ? _c('m-swiper', {
    attrs: {
      "data": _vm.product.images
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('m-content', {
    attrs: {
      "data": _vm.product,
      "channel": _vm.channel,
      "like": _vm.product.recommend_item
    },
    on: {
      "update": _vm.update
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('m-footer', {
    attrs: {
      "id": _vm.productId,
      "res": _vm.product
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-017cdb90"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Detail/Detail.vue
// module id = 507
// module chunks = 0